/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanRound } from './PlanRound';
import {
    PlanRoundFromJSON,
    PlanRoundFromJSONTyped,
    PlanRoundToJSON,
    PlanRoundToJSONTyped,
} from './PlanRound';

/**
 * 
 * @export
 * @interface PlanWorkout
 */
export interface PlanWorkout {
    /**
     * 
     * @type {string}
     * @memberof PlanWorkout
     */
    idClient: string;
    /**
     * 
     * @type {string}
     * @memberof PlanWorkout
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanWorkout
     */
    deckId: string;
    /**
     * 
     * @type {Array<PlanRound>}
     * @memberof PlanWorkout
     */
    rounds: Array<PlanRound>;
    /**
     * 
     * @type {string}
     * @memberof PlanWorkout
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanWorkout
     */
    sortKey: number;
}

/**
 * Check if a given object implements the PlanWorkout interface.
 */
export function instanceOfPlanWorkout(value: object): value is PlanWorkout {
    if (!('idClient' in value) || value['idClient'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('rounds' in value) || value['rounds'] === undefined) return false;
    if (!('sortKey' in value) || value['sortKey'] === undefined) return false;
    return true;
}

export function PlanWorkoutFromJSON(json: any): PlanWorkout {
    return PlanWorkoutFromJSONTyped(json, false);
}

export function PlanWorkoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanWorkout {
    if (json == null) {
        return json;
    }
    return {
        
        'idClient': json['idClient'],
        'name': json['name'],
        'deckId': json['deckId'],
        'rounds': ((json['rounds'] as Array<any>).map(PlanRoundFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'sortKey': json['sortKey'],
    };
}

export function PlanWorkoutToJSON(json: any): PlanWorkout {
    return PlanWorkoutToJSONTyped(json, false);
}

export function PlanWorkoutToJSONTyped(value?: PlanWorkout | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idClient': value['idClient'],
        'name': value['name'],
        'deckId': value['deckId'],
        'rounds': ((value['rounds'] as Array<any>).map(PlanRoundToJSON)),
        'description': value['description'],
        'sortKey': value['sortKey'],
    };
}

